<template>
  <div
    class="grocery-bag-block"
  >
    <div class="grocery-bag-block--inner-wrapper">
      <div
        class="testimonial-quotes"
        v-text="'”'"
      />
      <div class="grocery-bag-block--inner-wrapper--content">
        <h3
          v-if="title || isEditable"
          v-edit="'Title'"
          class="grocery-bag-block--inner-wrapper--title"
          v-text="title"
        />
        <p
          v-if="comment || isEditable"
          v-edit="'Comment'"
          class="grocery-bag-block--inner-wrapper--comment"
          v-text="comment"
        />
        <p
          v-if="user || isEditable"
          v-edit="'User'"
          class="grocery-bag-block--inner-wrapper--user"
          v-text="`- ${user}`"
        />
      </div>
      <div
        class="testimonial-quotes text-right"
        v-text="'”'"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: "TestimonialBlock",
    props: {
      title: {
        type: String,
        default: ""
      },
      comment: {
        type: String,
        default: ""
      },
      user: {
        type: String,
        default: ""
      }
    }
  }
</script>

<style lang="scss">
@import '../GroceryBagBlock/groceryBagBlock';
</style>
